{
  "members": "{{count}} participant",
  "members_plural": "{{count}} participants",
  "members-title": "Participants",
  "Groups": "Groups",
  "Other groups": "Other groups",
  "Add participants": "Add participants",
  "Step 1: ": "Step 1: ",
  "Add one email per line.": "Add one email per row.",
  "Step 2: Choose realm for all participants.": "Step 2: Choose realm for all participants.",
  "Select realm": "Select realm",
  "Select realm for all participants": "Select realm for all participants",
  "Are you sure you want to remove ": "Are you sure you want to remove? ",
  "Building CSV": "Creating CSV",
  "found-groupmembers": "Found {{count}} group member",
  "found-groupmembers_plural": "Found {{count}} group members",
  "Filtered CSV": "Filtered CSV",
  "Participant": "Participant",
  "Organization": "Organization",
  "Select an organization": "Select an organization",
  "Added": "Added",
  "Sort by": "Sort by",
  "add-user": "Add {{count}} participant",
  "add-user_plural": "Add {{count}} participants"
}
